import type React from 'react'
import { Provider } from 'react-redux'

import { store } from './store'

// @todo review, moved from test branch after merging, need to review a reason of that
// export const GlobalStoreContext = createContext(null)
// const useGlobalStore = () => useContext(GlobalStoreContext)
// export const GlobalStoreProvider = ({ children }) => {
//   const globalStore = useGlobalStore()
//
//   return <Provider store={globalStore}>{children}</Provider>
// }

export const StoreProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => <Provider store={store}>{children}</Provider>
